export const InventoryFormOnUpdate = Object.freeze({
	OverwriteRecordDbId: 1,
	OverwriteRecordPk: 2,
	NewRecord: 3,
});
